var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._g(
      _vm._b(
        {
          class: _vm.$style.input,
          attrs: {
            value: _vm.value,
            label: _vm.label,
            type: _vm.type,
            mask: _vm.mask,
            placeholder: _vm.placeholder,
            "return-masked-value": _vm.returnMaskedValue,
            color: "#38AA3F"
          },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event)
            }
          }
        },
        "v-text-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/InputField.vue?vue&type=template&id=985ecd00&
// module id = null
// module chunks = 